import navBackImgSrc from "$/nav-back.svg";
import footPrint from "$/footprint-white.svg";
import { useRouter } from "@tanstack/react-router";
import { Portal } from "./Portal";
import { SELECTOR } from "%/constant";
import { twMerge } from "tailwind-merge";
import { ReactNode } from "react";

interface HeaderProps {
  title?: string;
  hasBackBtn?: boolean;
  hasFootPrint?: boolean;
  className?: string;
  children?: ReactNode;
}
export const Header = ({
  title,
  hasBackBtn,
  children,
  hasFootPrint = false,
  className,
}: HeaderProps) => {
  const { history } = useRouter();
  return (
    <header
      className={twMerge(
        "flex sticky top-0 z-10 justify-between items-center p-3 h-14 backdrop-blur-md flex-0",
        className
      )}
    >
      {hasBackBtn && (
        <button onClick={() => history.back()} className="-mr-6">
          <img src={navBackImgSrc} alt="뒤로가기 아이콘" />
        </button>
      )}

      <span className="pl-7 m-auto text-base font-bold">{title}</span>
      {hasFootPrint && <img src={footPrint} alt="강아지 발자국" />}
      {children}
    </header>
  );
};

export const LayoutHeaderInButton = (props: HeaderProps) => (
  <Portal id={SELECTOR.HEADER}>
    <Header {...props} />
  </Portal>
);
